import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getErrorHttpMessage } from "utils";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { getCotizacionesHttp } from "actions/cotizacion";
import { StoreType } from "../types/genericTypes";
import { useGestionCotizacion } from "modules/gestionCotizacion";

export const useCotizaciones = () => {
  const intl = useIntl();
  const idUsuario = useSelector((state: StoreType) => state?.app?.user?.data?.id_usuario || 0);
  const [searchParams] = useSearchParams();
  const idCotizacionUrl = searchParams.get("idc");

  const [procesando, setProcesando] = useState<boolean>(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [mensajeAlert, setMensajeAlert] = useState("");
  const handleisAlertOpen = () => setIsAlertOpen(true);
  const handleisAlertClose = () => setIsAlertOpen(false);

  const [cotizaciones, setCotizaciones] = useState<any[]>([]);

  // Paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Gestión de la cotización (estado, acciones y botones del modal)
  const gestion = useGestionCotizacion({
    idUsuario,
    notificar: (mensaje) => {
      setMensajeAlert(mensaje);
      handleisAlertOpen();
    },
    onCargando: setProcesando,
  });

  // Modal de detalle de la cotización
  const [isAlertOpenDetalleCotizacion, setIsAlertOpenDetalleCotizacion] = useState(false);
  const handleisAlertOpenDetalleCotizacion = () => setIsAlertOpenDetalleCotizacion(true);
  const handleisAlertCloseDetalleCotizacion = () => {
    setIsAlertOpenDetalleCotizacion(false);
    gestion.reiniciar();
  };

  // Bitácora de cotización
  const [idCotizacionBitacora, setIdCotizacionBitacora] = useState<number | null>(null);
  const abrirBitacora = (idCotizacion: number) => setIdCotizacionBitacora(idCotizacion);
  const cerrarBitacora = () => setIdCotizacionBitacora(null);

  const getCotizaciones = useCallback(
    async (params?: { search?: string; fecha1?: string; fecha2?: string }) => {
      try {
        setProcesando(true);
        const lista = await getCotizacionesHttp(params);
        setCotizaciones(lista);
      } catch (error) {
        setMensajeAlert(
          getErrorHttpMessage(error) || intl.formatMessage({ id: "get_elementos_error" })
        );
        handleisAlertOpen();
      } finally {
        setProcesando(false);
      }
    },
    []
  );

  useEffect(() => {
    getCotizaciones();
  }, []);

  // Abrir directo desde la URL (?idc=)
  useEffect(() => {
    if (!idCotizacionUrl) return;
    gestion.cargarCotizacion(idCotizacionUrl);
    handleisAlertOpenDetalleCotizacion();
  }, [idCotizacionUrl]);

  const handleChangePage = (_: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return {
    intl,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    cotizaciones,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    // modal de detalle
    isAlertOpenDetalleCotizacion,
    handleisAlertOpenDetalleCotizacion,
    handleisAlertCloseDetalleCotizacion,
    // bitácora
    abrirBitacora,
    idCotizacionBitacora,
    cerrarBitacora,
    // todo lo de la cotización
    gestion,
  };
};